import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import Spinner from '../../../../components/spinner/spinner';

const AppointmentDetailsContext = createContext(null);

const AppointmentDetailsProvider = ({ children }) => {
    const { apptId } = useParams();
    const [appointmentDetails, setAppointmentDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const getAppointmentDetails = async (id) => {
            try {
                setLoading(true);
                const url = `${APIUtils.getAPIEndpoint('myappointment-details')}/${id}`;
                const res = await httpClient.get(url).then(res => res.data);
                if (res.status === 'success') {
                    setAppointmentDetails(res.data);
                }
                // else {
                //     setDepartments([]);
                // }
            } catch (error) {
                console.error('Error fetching appointment details:', error);
                setError(error);
                if (error?.cause?.response?.data?.message) {
                    Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                    return;
                }
                Swal.fire('Something Went Wrong!', '', 'error');
            } finally {
                setLoading(false);
            }
        };
        getAppointmentDetails(apptId);
    }, [apptId]);

    if (error) {
        return <>Error while fetching appointment details. Retry</>;
    }

    if (loading) {
        return (
            <div style={{height: '500px', width: '100%'}}>
                <Spinner inline={false} />
            </div>
        );
    }

    return (
        <AppointmentDetailsContext.Provider value={{ appointmentDetails, loading, error, setAppointmentDetails }}>
            {children}
        </AppointmentDetailsContext.Provider>
    );
};

export const useAppointmentDetailsContext = () => {
  const context = useContext(AppointmentDetailsContext);
  if (!context) {
    throw new Error('useAppointmentDetailsContext must be used within AppointmentDetailsProvider');
  }
  return context;
};

export default AppointmentDetailsProvider;

AppointmentDetailsProvider.propTypes = {
    children: PropTypes.node.isRequired
};